if (!window.Eurus.loadedScript.has('sticky-atc.js')) {
  window.Eurus.loadedScript.add('sticky-atc.js');

  requestAnimationFrame(() => {
    document.addEventListener('alpine:init', () => {
      Alpine.data('xStickyATC', (sectionId, is_combined) => ({
        openDetailOnMobile: false,
        currentAvailableOptions: [],
        options: [],
        init() {
          document.addEventListener(`eurus:product-page-variant-select:updated:${sectionId}`, (e) => {
            this.renderVariant(e.detail.html);
            this.renderProductPrice(e.detail.html);
            this.renderMedia(e.detail.html);
            this.renderProductTitle(e.detail.html);
          });

          // Use multiple ticks to ensure DOM is fully ready
          this.$nextTick(() => {
            setTimeout(() => {
              this.reorderStickyElements();
            }, 100);
          });
        },
        reorderStickyElements() {
          const stickyContainer = document.getElementById(`sticky-add-to-cart-${sectionId}`);
          if (!stickyContainer) return;

          const detailContainer = stickyContainer.querySelector('[x-show="openDetailOnMobile"]');
          if (!detailContainer) return;

          const titleAnchor = detailContainer.querySelector('a[href*="/products/"]');
          if (!titleAnchor) return;

          const quantitySelector = stickyContainer.querySelector(`[id="Quantity-sticky-${sectionId}"]`)?.closest('div[x-data*="qty"]')?.parentElement;

          const allPriceElements = stickyContainer.querySelectorAll(`#price-sticky-${sectionId}`);
          let priceElementInsideAnchor = null;
          let priceElementOutsideAnchor = null;

          allPriceElements.forEach(el => {
            if (el && el.isConnected) {
              if (titleAnchor.contains(el)) {
                priceElementInsideAnchor = el;
              } else if (!el.classList.contains('md:!hidden')) {
                priceElementOutsideAnchor = el;
              }
            }
          });

          const productOptionsLink = stickyContainer.querySelector('a[href^="#product-form-"]')?.closest('div.mt-5, div[class*="rtl:text-right"]');

          if (priceElementInsideAnchor && priceElementInsideAnchor.isConnected && titleAnchor && titleAnchor.isConnected) {
            titleAnchor.insertAdjacentElement('afterend', priceElementInsideAnchor);
          }

          const priceElement = priceElementInsideAnchor || priceElementOutsideAnchor;

          if (quantitySelector && quantitySelector.isConnected && !detailContainer.contains(quantitySelector)) {
            let quantityWrapper = quantitySelector.parentElement;
            if (!quantityWrapper || !quantityWrapper.classList.contains('quantity-wrapper-sticky')) {
              quantityWrapper = document.createElement('div');
              quantityWrapper.className = 'quantity-wrapper-sticky flex flex-col justify-center items-center gap-2 mx-5';

              const quantityLabel = document.createElement('p');
              quantityLabel.textContent = 'Quantity';
              quantityLabel.className = 'quantity-label text-base font-bold';

              if (quantitySelector.parentNode) {
                quantitySelector.parentNode.insertBefore(quantityWrapper, quantitySelector);
                quantityWrapper.appendChild(quantityLabel);
                quantityWrapper.appendChild(quantitySelector);
              }
            }

            if (quantityWrapper && quantityWrapper.isConnected && titleAnchor && titleAnchor.isConnected) {
              titleAnchor.insertAdjacentElement('afterend', quantityWrapper);
            }
          }

          const originalQuantityLabels = stickyContainer.querySelectorAll('p');
          originalQuantityLabels.forEach(label => {
            if (label && label.isConnected && label.textContent.trim() === 'Quantity' && !label.classList.contains('quantity-label')) {
              label.style.display = 'none';
            }
          });

          const quantityWrapper = stickyContainer.querySelector('.quantity-wrapper-sticky');
          if (priceElement && priceElement.isConnected && quantityWrapper && quantityWrapper.isConnected) {
            quantityWrapper.insertAdjacentElement('afterend', priceElement);
          }

          if (productOptionsLink && productOptionsLink.isConnected && !detailContainer.contains(productOptionsLink)) {
            const insertAfter = priceElement || quantityWrapper || titleAnchor;
            if (insertAfter && insertAfter.isConnected) {
              insertAfter.insertAdjacentElement('afterend', productOptionsLink);
            }
          }
        },
        renderProductPrice(html) {
          const destinations = document.querySelectorAll(`.price-sticky-${sectionId}`);
          destinations.forEach((destination) => {
            const source = html.getElementById('price-sticky-' + sectionId);
            if (source && destination) destination.innerHTML = source.innerHTML;
          })
        },
        renderMedia(html) {
          const destination = document.getElementById('product-image-sticky-' + sectionId);
          const source = html.getElementById('product-image-sticky-' + sectionId);

          if (source && destination) destination.innerHTML = source.innerHTML;
        },
        renderProductTitle(html) {
          const destination = document.getElementById('product-title-sticky-' + sectionId);
          const source = html.getElementById('product-title-sticky-' + sectionId);

          if (source && destination) destination.innerHTML = source.innerHTML;
        },
        renderVariant(html) {
          const destination = document.getElementById('variant-update-sticky-' + sectionId);
          const source = html.getElementById('variant-update-sticky-' + sectionId);
  
          if (source && destination) destination.innerHTML = source.innerHTML;
        },
        changeOptionSticky(event) {
          Array.from(event.target.options).forEach((option) => {
            option.removeAttribute('selected');
            if (option.selected) option.setAttribute('selected', '');
          });
          const input = event.target.selectedOptions[0];
          const targetUrl = input.dataset.productUrl;
          const variantEl = document.getElementById('variant-update-sticky-' + sectionId);
          document.dispatchEvent(new CustomEvent(`eurus:product-page-variant-select-sticky:updated:${sectionId}`, {
            detail: {
              targetUrl: targetUrl,
              variantElSticky: variantEl
            }
          }));
        }
      }))
    })
  })
}